import React, { useContext } from 'react'
import { withJsonFormsControlProps } from '@jsonforms/react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'
import { DesignContext } from 'contexts/DesignContext'
import HeaderControl, { headerControlTester } from './Header'
import BodyControl, { bodyControlTester } from './Body'
import FooterControl, { footerControlTester } from './Footer'
import { materialRenderers, materialCells } from '@jsonforms/material-renderers'
import { JsonForms } from '@jsonforms/react'
import { Formik } from 'formik'
import { checkError } from 'designer/component/validation'

const FormControl = (props) => {
  const renderers = [
    ...materialRenderers,
    { tester: headerControlTester, renderer: HeaderControl },
    { tester: bodyControlTester, renderer: BodyControl },
    { tester: footerControlTester, renderer: FooterControl },
  ]
  const { config, schema, uischema } = props

  const designContext = useContext(DesignContext)
  const { jsonForm } = designContext

  const initialValues = {}
  const validate = (values) => {
    let errors = checkError(jsonForm, values)
    return errors
  }

  return (
    <Formik initialValues={initialValues} validate={validate}>
      <JsonForms
        schema={schema}
        uischema={uischema}
        config={{ ...config, droppableId: uischema.key }}
        renderers={renderers}
        cells={materialCells}
      />
    </Formik>
  )
}

export const formControlTester = rankWith(3, scopeEndsWith('layout'))

export default withJsonFormsControlProps(FormControl)
